export const PAGE_WIDTH = {
  XXL: 1092,
  XL: 950,
  LG: 802,
  MD: 645,
  SM: 488,
  XS: 320,
};

export const DEFAULT_ROWS_COUNT_BEFORE_BANNER = 15;

export const ROWS_COUNT_BEFORE_BANNER = 3;

export const ROWS_COUNT_BEFORE_DESKTOP_IN_LIST_BANNER = 2;

export const SIDE_PADDING = 15;
